export default __webpack_public_path__ + "static/media/realtimerendering.69b01b0d.webp";